module.exports = __webpack_public_path__ + "img/angst_960.1224750f.webp";